import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { JdihItem } from '@/types/jdih'
import { formatEpoch, formatFileSize } from '@/utils/formatter'

const JdihCard: React.FC<{ data: JdihItem; isNew: boolean }> = ({ data, isNew = false }) => {
  const router = useRouter()
  const { t } = useTranslation()

  return (
    <div className='relative flex flex-col items-center rounded-lg border border-neutral-border transition-all duration-300 lg:hover:border-red lg:hover:shadow-flay'>
      <Link
        href={`/service/jdih/${data.slug}`}
        className='absolute inset-0'
      />
      <div className='flex w-full items-center gap-4 px-3.5 py-3'>
        <div className='flex h-19 w-19 basis-19 flex-col rounded-lg bg-neutral-disable'>
          <div className='flex h-full items-center justify-center'>
            <span className='kek-pdf text-[28px] text-red' />
          </div>

          <div className='flex h-fit w-full justify-center rounded-b-lg bg-yellow px-1.5 py-1'>
            <span className='text-xxs font-medium text-dark'>{formatFileSize(Number(data.file.fileSize))}</span>
          </div>
        </div>

        <div className='flex flex-1 flex-col gap-1 lg:gap-3'>
          <div className='flex items-center gap-2'>
            {isNew && (
              <div className='rounded-full bg-state-error-default px-1 text-[11px] font-medium uppercase leading-4 text-white'>
                {t('common:new')}
              </div>
            )}
            <p className='line-clamp-2 text-sm font-semibold tracking-[-0.084px] text-dark lg:text-base lg:font-medium lg:tracking-[-0.176px]'>
              {data.title}
            </p>
          </div>
          <small className='line-clamp-2 text-xs text-gray-2'>{data.description}</small>
        </div>
      </div>

      <div className='flex w-full items-center justify-between rounded-b-lg bg-red/10 px-3.5 py-2 lg:py-3'>
        <p className='text-xs font-bold leading-normal text-gray-1'>{data.jdihType}</p>
        <p className='text-xs leading-normal text-black'>
          {formatEpoch(Number(data.publishedDate ?? ''), 'dd LLLL yyyy', router.locale)}
        </p>
      </div>
    </div>
  )
}

export default JdihCard
